import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXCardModal from "../../../../Components/Modals/BMXCardModal/BMXCardModal";
import EditServicePartForm from "../../Forms/ServiceForms/ServicePartForm/EditServicePartForm/EditServicePartForm";

const EditServicePartModal = (props) => {
    const { handleHide, show, header } = props;
    const { t } = useTranslation();

    return (
        <BMXCardModal
            width="450px"
            height="max-content"
            header={header || t("global:editservicepart")}
            open={show}
            onClose={handleHide}
            onOutside={false}
        >
            <EditServicePartForm {...props} />

        </BMXCardModal>
    );
};

export default connectModal({ name: "editServicePartModal" })(EditServicePartModal);